import { Component, Inject } from '@angular/core';
import { SalesDocument, TaxRate } from '@icc/b2b/shared';
import { DialogRef, DIALOG_DATA } from '@icc/ui';
import { SalesDocumentService } from '../sales-document.service';

@Component({
    selector: 'icc-document-tax-dialog',
    templateUrl: './document-tax-dialog.component.html',
    styleUrls: ['./document-tax-dialog.component.scss'],
})
export class DocumentTaxDialogComponent {

	mode!: 'default' | 'global' | 'position';
	taxRateId: number | null = null;
	taxRates: TaxRate[] = [];
	taxRateCalculationMethod: 'netSummary' | 'netPosition' | 'grossSummary';

    constructor(
        @Inject(DIALOG_DATA)
        public data: {
            document: SalesDocument;
            taxRateId: number | null;
			taxRates: TaxRate[];
        },
        private dialogRef: DialogRef,
        private salesDocumentService: SalesDocumentService,
    ) {
		this.mode = !data.document.isCustomTaxRatesMode ? 'default' : data.document.isOneTaxRateMode ? 'global' : 'position';
		this.taxRateId = data.taxRateId;
		this.taxRates =  data.taxRates;
		this.taxRateCalculationMethod = data.document.taxRateCalculationMethod;
	}

    changeOneTaxRateMode(mode: 'default' | 'global' | 'position') {
		this.mode = mode;
        this.salesDocumentService.changeCustomTaxRatesMode(this.data.document, mode !== 'default');

        if (mode !== 'default') {
            if (mode === 'global') {
                this.salesDocumentService.setOneTaxRateToWholeDocument(this.data.document, this.taxRateId);
            }
            this.salesDocumentService.changeOneTaxRateMode(this.data.document, mode === 'global');
        } else {
            this.salesDocumentService.changeOneTaxRateMode(this.data.document, false);
        }
    }

	changeTaxRate(taxRateId:number | null){
		this.taxRateId = taxRateId;
        this.salesDocumentService.setOneTaxRateToWholeDocument(this.data.document, Number(taxRateId));
	}

	changeVatCalculationMode(taxRateCalculationMethod:'netSummary' | 'netPosition' | 'grossSummary'){
		this.taxRateCalculationMethod = taxRateCalculationMethod;
        this.salesDocumentService.changeVatCalculationMode(this.data.document, taxRateCalculationMethod);
	}

    close() {
        this.dialogRef.close();
    }
}
